<template>
  <video
    :srcObject.prop="srcObject"
    controls
    autoplay
    style="object-fit: fill"
    webkit-playsinline
    playsinline
    allowfullscreen="true"
    webkitallowfullscreen="true"
    mozallowfullscreen="true"
    x5-video-player-type="h5"
    x5-video-player-fullscreen="true"
    muted
    width="100%"
    height="100%"
  ></video>
</template>
<script>
import { SrsRtcPlayerAsync } from '@/components/srs-player/SrsRtcPlayerAsync';
import 'webrtc-adapter';
import { mapGetters, mapActions } from 'vuex';

export default {
  props: ['isPlaying'],

  data: () => ({
    sdk: null,
    srcObject: null,
    sessionId: '',
    simulatorDrop: '',
  }),

  mounted() {
    this.startPlay();
  },
  computed: {
    ...mapGetters({
      arena: 'general/selectedArena',
      arenas: 'general/arenas',
      autoScale: 'general/videoAutoScale',
      config: 'general/config',
    }),
    streamUrlSelector() {
      return this.config.language === 'vn'
        ? 'https://srs.credit28.com:443/rtc/v1/whep/?app=live&stream=a1vn3'
        : 'https://srs.credit28.com:443/rtc/v1/whep/?app=live&stream=livestream';
    },
  },
  methods: {
    startPlay() {
      console.log('start play');
      this.showVideo = true; // Close PC when user replay.

      if (this.sdk) {
        this.sdk.close();
      }

      this.sdk = SrsRtcPlayerAsync(); // https://webrtc.org/getting-started/remote-streams
      console.log(this.sdk.stream);
      this.srcObject = this.sdk.stream;

      const url = this.streamUrlSelector;
      this.sdk
        .play(url)
        .then((session) => {
          this.sessionId = session.sessionid;
          this.simulatorDrop = session.simulator + '?drop=1&username=' + session.sessionid;
          console.log({ session });
        })
        .catch((reason) => {
          this.sdk.close();
          this.showVideo = false;
          console.error(reason);
        });
    },
  },
  watch: {
    streamUrlSelector(newVal) {
      if (newVal) {
        this.startPlay();
      }
    },
  },
};
</script>
